import * as React from "react";
import { User, Category, Case } from "../api/classes";
import {
  Avatar,
  Typography,
  Select,
  MenuItem,
  Button
} from "@material-ui/core";
import { connect } from "react-redux";
import { GlobalState } from "../store";
import * as actions from "../store/cases/actions";
import FolderIcon from "@material-ui/icons/Folder";
import * as constants from "../api/constants";
import CasePicker from "./dialogs/casePicker";

interface Props {
  value: string;
  caseID: number;
  onChange?: () => void;
  onSelect: (id: string) => void;
  style?: React.CSSProperties;
  cases: Case[];
}
class CaseSelect extends React.Component<Props> {
  state = {
    showCasePicker: false
  };
  handleChange = e => {
    this.props.onSelect(e);
    this.setState({ showCasePicker: false });
  };
  render() {
    const { value } = this.props;
    let caseObj = undefined;
    if (this.props.caseID && this.props.cases) {
      caseObj = this.props.cases.find(i => i.id === this.props.caseID);
    }
    return (
      <div>
        <CasePicker
          open={this.state.showCasePicker}
          onSelect={this.handleChange}
          onClose={() => this.setState({ showCasePicker: false })}
        />
        <Button
          variant="outlined"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            fontSize: 16,
            textTransform: "none"
          }}
          onClick={() => this.setState({ showCasePicker: true })}
        >
          <FolderIcon color="action" />
          <Typography
            variant="body1"
            style={{ flex: 1, fontSize: 16, marginLeft: 8 }}
          >
            {caseObj ? caseObj.title : "Select a Case"}
          </Typography>
        </Button>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: Props) => ({
    cases: state.cases.list
  }),
  dispatch => ({})
)(CaseSelect);



// WEBPACK FOOTER //
// ./src/components/caseSelect.tsx